import { Divider } from "@mui/material";
import React from "react";
import LineGenerator from "./LineGenerator";

const LineCreator = ({
  index,
  divider2Padding = 0.1,
  divider2Style,
  divider2Height,
  divider3Style,
}) => {
  return (
    <>
      <Divider
        sx={{
          bgcolor: "#000",
          p: 0.1,
          height: "40px !important",
          position: "absolute",
          right: 15,
          top: "23%",
          transform: "rotate(90deg)",
        }}
      />
      <Divider
        sx={{
          bgcolor: "#000",
          p: divider2Padding,
          height: `${divider2Height} !important`,
          position: "absolute",
          right: -5,
          top: `${
            index % 2 == 1 ? `calc(23% - ${divider2Style})` : "calc(23% + 19px)"
          }`,
        }}
      />
      <Divider
        sx={{
          bgcolor: "#000",
          p: 0.1,
          height: "40px !important",
          position: "absolute",
          transform: "rotate(90deg)",
          right: -25,
          top: divider3Style,
          display: `${index % 2 == 1 && "none"}`,
        }}
      />
    </>
  );
};

export default LineCreator;
